import { Component } from '@angular/core';

@Component({
  selector: 'app-p404',
  standalone: false,
  templateUrl: '404.component.html'
})
export class P404Component {

  constructor() { }

}
